import { ApiBase, IPaginatedData } from './ApiBase'
import { NextInspectionDto, ISchedule } from './types/checklist'

export interface NextInspectionsParams {
  page?: number
  sort?: string
  direction?: 'asc' | 'desc'
  title?: string
  project_id?: number[]
  start_date?: string
  end_date?: string
}

/**
 * Loads schedules from the backend
 */
export default class ScheduleApi extends ApiBase {
  public async index(checklistId: number) {
    const response = await this.get<ISchedule[]>(`/checklists/${checklistId}/schedules`)
    return response.data
  }

  /**
   * List paginated inspections for the current user.
   * Accepts filter/sort/page params that are forwarded to the backend.
   */
  public async nextInspections(params: NextInspectionsParams = {}): Promise<IPaginatedData<NextInspectionDto>> {
    const response = await this.get<NextInspectionDto[]>('/schedules/next_inspections', params)
    return this.paginateResponse(response)
  }

  /**
   * List the inspections for the next week by ressource
   */
  public byResource(id: number) {
    return this.get<NextInspectionDto[]>(`/schedules/by_ressource?ressource_id=${id}`)
  }

  /**
   * Get the latest ResultSet for a specific schedule (the last one created for the schedule, if any)
   *
   * @param id Schedule ID
   */
  public latestResultSet(id: number) {
    return this.get<ISchedule>(`/schedules/${id}/latest_result_set`)
  }
}
